var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron no_space dmbs-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Recintos'))+" "+_vm._s(_vm.provincia))]),(_vm.recintosWeb)?_c('lista-recintos',{attrs:{"listadoRecintos":_vm.recintosWeb}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }